export const DescriptionList: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <dl className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-4">
      {children}
    </dl>
  );
};
